<p>redirect-back-from-editor works!</p>
